export const SERVICES = [
    {
        id: 0,
        name: "Translation & Localisation",
        description: "By localising your content, you increase your chances of effectively communicating with your target audiences across the globe.",
        details: ["Professional Translation", "Language Localisation", "Transcreation & Adaptation"],
        image: '/images/services/service1.png'
    },
    {
        id: 1,
        name: "Media Translation",
        description: "Localise your audio and video content to broadcast your message across cultural, liguistic and geographical boundaries.",
        details: ["Dubbing & Voiceover", "Subtitles & Captioning", "Transcription"],
        image: '/images/services/service2.png'
    },
    {
        id: 2,
        name: "Website & Software Translation",
        description: "Reach millions of online consumers and customers by localizing websites, apps and interfaces to their native language.",
        details: ["Website Translation", "Software Localisation", "SEO Content Localisation"],
        image: '/images/services/service3.png'
    }
];